import { BaseMapInfoWindowBuilder } from "../../../_shared/interfaces/maps/base-map-info-window-builder";
import { FuelLevel } from "../models/fuel-level.model";

export class FuelLevelMapInfoWindowBuilder extends BaseMapInfoWindowBuilder {
  constructor(private readonly translate: (key: string) => string) {
    super();
  }

  private label(key: string): string {
    return this.escapeHTML(this.translate(key));
  }

  override buildMapInfoWindowHTML(data: FuelLevel): string {
    const vehicle = this.escapeHTML(data.assetName);
    const driver = this.escapeHTML(data.driverName);
    const location = this.escapeHTML(data.location);
    const fuelLevel = `${data.fuelLevel}ℓ`;
    const distanceToEmpty = data.distanceToEmpty ? `${data.distanceToEmpty}km` : this.label('fuelShared.charts.notAvailable');
    const lowFuelLevel = data.fuelLevel! <= data.lowFuelLevelThreshold ? 'low-fuel-level' : '';

    return `
        <div class="fc-iw">
          <style>
            .gm-style-iw-ch { 
              padding: 0 !important;  
            }
    
            .gm-style-iw-d { 
              max-height: none !important;
              overflow: visible !important;
              overflow-x: hidden !important; 
            }
    
            .gm-style-iw, .gm-style-iw-c { 
              max-width: none !important;
              overflow: visible !important;
              padding: 16px !important;
              height: 175px !important;
              width: 267px !important;
            }

            /* Rows layout: two columns (label + value), single-line, spaced vertically */
            .fc-iw .rows {
              display: grid;
              grid-template-columns: auto 1fr;
              column-gap: 12px;
              row-gap: 8px;
              align-items: start;
            }
    
            .fc-iw .label {
              color: #9FA1A4;
              font-weight: 400;
              align-self: start;
            }
    
            .fc-iw .val {
              align-self: start;
              overflow-wrap: anywhere;
              line-height: 1.25;
              color: black;
            }

            .fc-iw .val.low-fuel-level {
              color: #ff7000;
            }
          </style>
    
          <div class="rows">
            <div class="label">${this.label('fuelShared.map.driver')}</div>              <div class="val">${driver}</div>
            <div class="label">${this.label('fuelShared.map.vehicle')}</div>             <div class="val">${vehicle}</div>
            <div class="label">${this.label('fuelShared.map.fuelLevel')}</div>          <div class="val ${lowFuelLevel}">${fuelLevel}</div>
            <div class="label">${this.label('fuelShared.map.location')}</div>            <div class="val">${location}</div>
            <div class="label">${this.label('fuelShared.map.distanceToEmpty')}</div>   <div class="val">${distanceToEmpty}</div>
          </div>
        </div>
      `;
  }
}